<template>
  <div class="row intestazione" v-if="orderedLabels" >
    <div class="col-md-12 d-flex is-justify-content-space-between">
      <div :class="'col-custom-' + (orderedLabels.length + 2)">{{trans.get('public.products-view.codart')}}</div>

      <etichetta v-for="(data, i) in orderedLabels" :etichetta="data" :key="i" :css="orderedLabels.length + 2"/>
      <div :class="'col-custom-' + (orderedLabels.length + 2)">Download</div>
    </div>

  </div>
</template>

<script>
import etichetta from "./etichetta";
export default {
  components: {
    etichetta
  },
  name: "datasheetHeading",
  props: ['datasheet'],
  data() {
    return {
      labelsToShow: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      codiceTipo: (this.datasheet.length > 0) ? this.datasheet[0].cod_tipo : false,
      newLabels: null,
      loaded: false,
      orderedLabels: null,
    }
  },
  mounted() {
    this.orderLabels
  },
  computed: {
    orderLabels() {
      let array = [];
      this.datasheet.forEach((el) => {
        array.push(el.id_ref_etichetta)
      })

      array.sort(function (x, y) {
        let xp = parseInt(x.substring(4))
        let yp = parseInt(y.substring(4))

        return xp === yp ? 0 : xp < yp ? -1 : 1
      })
      this.orderedLabels = array
    },
  },
  methods: {
    parseLabels() {
      let newLabels = []
      this.labelsToShow.forEach((el) => {
        let temp = this.codiceTipo + '-' + el
        newLabels.push(temp)
      })
      this.newLabels = newLabels
      this.$emit('labels', newLabels)
      this.loaded = true
    },
  }
}
</script>

<style lang="scss" scoped>
.row.intestazione {
  font-size: 1rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }
  width: 100%;
  max-width: 100%;
  @for $i from 3 through 14 {
    .col-custom-#{$i} {
      width: calc(100% / #{$i});
      text-align: center;
      padding: 0 5px;
      //@media (max-width: 1500px) and (min-width: 577px) {
      //  text-overflow: ellipsis;
      //  white-space: nowrap;
      //  overflow: hidden;
      //}
    }
  }
}
</style>
